module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "industries-section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._t("title")], 2), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._t("text")], 2), _vm._v(" "), _c('div', {
    staticClass: "row industries-grid mx-lg-n5"
  }, _vm._l((_vm.gridElements), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "col-12 col-md-6 col-lg-4 px-lg-5 industries-grid__single"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: item.routeName
        }
      }
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (_vm.getImagePath(item.image)),
        expression: "getImagePath(item.image)"
      }],
      attrs: {
        "alt": item.title
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "sr-only sr-only-focusable"
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": {
          name: item.routeName
        }
      }
    }, [_vm._v(_vm._s(item.title))])], 1)
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c09b7cc6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/industries/IndustriesGrid.vue
// module id = 2024
// module chunks = 5